class ImageEvidenceController {
    constructor($scope,userInfo, AppConfig, ImageAPI, $stateParams, pageTitle,QueryAPI, $sce,$filter) {

        "ngInject";

        $scope.image = null;
        $scope.publicKeyHtml = null;
        this.userInfo = userInfo;
        this.QueryAPI=QueryAPI;
        this.userInfo.setUser(this.appUser);

        this.AppConfig = AppConfig;
        this.Hash_type={
         0:"SHA256",
         1:"SM3",
      }

        if(!this.userInfo.isGuest()){
            ImageAPI.one($stateParams.id).one('evidence').get().then(
                function (image) {
                    $scope.image = image;
                    $scope.publicKeyHtml = $sce.trustAsHtml($scope.image.public_key.replace(/\n/g, "<br/>"));

                    pageTitle.setTitle($filter('translate')('page-evidence-text019') +' - '+ image.title);
                }
            );
        }else{
            this.QueryAPI.one().get({'id': $stateParams.id, 'type': 'image'}).then(
                function (image) {
                    $scope.image = image;
                    $scope.publicKeyHtml = $sce.trustAsHtml($scope.image.public_key.replace(/\n/g, "<br/>"));
                    pageTitle.setTitle($filter('translate')('page-evidence-text019')  +' - '+ image.title);
                }
            );
        }
    }
}

export default ImageEvidenceController;



// WEBPACK FOOTER //
// ./src/app/components/page/evidence/image-evidence/image-evidence.controller.js